import React from 'react'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import { FolderOpen } from 'lucide-react'

function formatActivityDate(dateStr) {
	if (!dateStr) return ''
	const d = new Date(dateStr)
	const now = new Date()
	const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
	const sevenDaysAgo = new Date(todayStart)
	sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

	if (d >= todayStart) {
		return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true })
	}
	if (d >= sevenDaysAgo) {
		return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })
	}
	return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

function SidebarLocationProjectRecent({ project }) {
	const updateHistory = project.updateHistory || []
	const isEmpty = updateHistory?.length === 0

	const sorted = updateHistory.slice().sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))

	return (
		// Last card in the sidebar: takes the space Project Partners leaves and runs
		// to the bottom of the screen, scrolling its own list rather than the panel.
		<div className="flex flex-col flex-1 min-h-0 border-t border-gray-200">
			<div className="px-4 py-3 border-b border-gray-100 flex-shrink-0">
				<div className="flex items-center gap-2">
					<svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth={2}
							d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
						/>
					</svg>
					<span className="text-sm font-semibold text-gray-900">Project Activity</span>
					{sorted.length > 0 && (
						<span className="text-xs px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-500">{sorted.length}</span>
					)}
				</div>
			</div>
			<div className="flex-1 min-h-0 overflow-y-auto">
				{isEmpty ? (
					<div className="text-center py-6">
						<svg className="w-5 h-5 mx-auto text-gray-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
							/>
						</svg>
						<p className="text-sm text-gray-400">No activity yet</p>
					</div>
				) : (
					<div className="flow-root px-4 pt-3">
						<ul className="-mb-6">
							{sorted.map((event, idx) => {
								const isLast = idx === sorted.length - 1
								return (
									<li key={idx} className="relative pb-6 last:pb-0">
										{!isLast && (
											<span className="absolute left-[15px] top-8 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
										)}
										<div className="relative flex items-start gap-3">
											<Avatar className="h-8 w-8 flex-shrink-0">
												{event.updatedBy?.image ? (
													<>
														<AvatarImage src={event.updatedBy.image} alt={event.updatedBy.name || ''} />
														<AvatarFallback className="text-xs bg-gray-200 text-gray-600">
															{(event.updatedBy.name || '?').charAt(0).toUpperCase()}
														</AvatarFallback>
													</>
												) : (
													<AvatarFallback className="bg-amber-50 text-amber-600">
														<FolderOpen className="w-3.5 h-3.5" />
													</AvatarFallback>
												)}
											</Avatar>
											<div className="min-w-0 flex-1 pt-0.5">
												<span className="text-sm font-medium text-gray-900">{event.updateNote}</span>
												{event.updatedBy?.name && (
													<p className="mt-0.5 text-xs text-gray-400">{event.updatedBy.name}</p>
												)}
												{event.updatedAt && (
													<p className="mt-0.5 text-xs text-gray-400">{formatActivityDate(event.updatedAt)}</p>
												)}
											</div>
										</div>
									</li>
								)
							})}
						</ul>
					</div>
				)}
			</div>
		</div>
	)
}

export default SidebarLocationProjectRecent
